import React from "react";
import "./contact.css";
import { Form, Button, Row, Col } from "react-bootstrap";

function Contact() {
  const submit = (e) => {
    e.preventDefault();

    alert("Message Send Success");
  };

  return (
    <div className="contact  container ">
      <div className="contact_left">
        <h1>Contact Info.</h1>
        <br />
        <p style={{ fontSize: "15px", fontWeight: "bold" }}>EMAIL</p>

        <h5>info@etemp.com</h5>
        <hr />
        <div className="py-3">
          <p style={{ fontSize: "15px", fontWeight: "bold" }}>Location</p>
          <h6>
            G-18, Ivoryterrace, Opp. Circuit House,Vadodara 390007, Gujarat,
            India
          </h6>
        </div>
      </div>
      <div className="contact_right">
        <h1>Leave Your Message</h1>
        <p style={{ fontSize: "15px", fontWeight: "bold" }}>
          Feel free to contact with us by using the form below
        </p>
        <br />
        <Form onSubmit={submit}>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicText">
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  style={{ padding: "15px" }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  style={{ padding: "15px" }}
                />
              </Form.Group>
            </Col>

            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Message"
                style={{ paddingBottom: "55px" }}
              />
            </Form.Group>

            <Button
              style={{ borderRadius: "50px" }}
              variant="dark"
              type="submit"
            >
              Send Us
            </Button>
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default Contact;
